import { PlateElement } from 'platejs/react';
import { useLink } from '@platejs/link/react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function LinkElement({
  children,
  element,
  ...rest
}) {
  const {
    props: linkProps
  } = useLink({
    element
  });
  return _jsx(PlateElement, {
    as: "a",
    element: element,
    style: {
      textDecoration: 'underline',
      fontSize: 'inherit',
      maxWidth: '100%',
      fontWeight: 'inherit'
    },
    ...linkProps,
    ...rest,
    children: children
  });
}
export default LinkElement;